<!-- @format -->

@if (courseUnitGroupEnrolmentRights?.length > 0) {
  <sis-contextual-notification variant="light" data-cy="different-version-purchase">
    <p>{{ "OPEN_UNIVERSITY.STUDY_OFFERING.DIFFERENT_VERSION_PURCHASES" | translate }}</p>
    <ul>
      @for (versionName of versionNames$ | async; track versionName) {
        <li>
          {{ versionName }}
        </li>
      }
    </ul>
  </sis-contextual-notification>
}
